export default "__VITE_ASSET__BvCS4vfr__"